import { useModal } from "@/features/modal/ModalStackManager";
import { DetailBadge } from "@/features/ui/detail/DetailBadge";
import { DetailContent } from "@/features/ui/detail/DetailContent";
import { DetailField } from "@/features/ui/detail/DetailField";
import { DetailHeader } from "@/features/ui/detail/DetailHeader";
import { DetailInformTitle } from "@/features/ui/detail/DetailInformTitle";
import { DetailLabel } from "@/features/ui/detail/DetailLabel";
import { DetailLink } from "@/features/ui/detail/DetailLink";
import { DetailLinkWrapper } from "@/features/ui/detail/DetailLinkWrapper";
import { DetailTitle } from "@/features/ui/detail/DetailTitle";
import { setExternalUserType } from "@/utils/externalUserType";
import timeUtil from "@/utils/timeUtil";
import { Checkbox, Space } from "@mantine/core";
import { PartnersGet200Response } from "@sizlcorp/sizl-api-document/dist/models";
import { AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";

const PartnerDetail = Object.assign(DetailHeader, {
  Title: DetailTitle,
  Inform: DetailInformTitle,
  Field: DetailField,
  Label: DetailLabel,
  Link: DetailLink,
  LinkWrapper: DetailLinkWrapper,
  Badge: DetailBadge,
  Content: DetailContent,
  CheckBox: Checkbox,
});

export interface PartnerDetailHeaderProps {
  data: AxiosResponse<PartnersGet200Response, any> | undefined;
}

export const PartnerDetailHeader = (params: PartnerDetailHeaderProps) => {
  const { data } = params;
  const { t } = useTranslation();
  const partner = data?.data?.rows && data?.data?.rows[0];
  const { openModal } = useModal();

  return (
    <>
      <PartnerDetail>
        <PartnerDetail.Title>
          [{t("partner.partner")}] {partner?.id}
        </PartnerDetail.Title>
        <Space h={8} />
        <PartnerDetail.Field>
          <PartnerDetail.Label>{t("partner.code")}</PartnerDetail.Label>
          <PartnerDetail.Content>{partner?.code}</PartnerDetail.Content>
        </PartnerDetail.Field>
        <PartnerDetail.Field>
          <PartnerDetail.Label>{t("partner.name")}</PartnerDetail.Label>
          <PartnerDetail.Content>{partner?.name}</PartnerDetail.Content>
        </PartnerDetail.Field>
        <PartnerDetail.Field>
          <PartnerDetail.Label>{t("partner.contact")}</PartnerDetail.Label>
          <PartnerDetail.Content>{partner?.contact}</PartnerDetail.Content>
        </PartnerDetail.Field>
        <PartnerDetail.Field>
          <PartnerDetail.Label>{t("partner.type")}</PartnerDetail.Label>
          <PartnerDetail.Content>
            <PartnerDetail.Badge>{t(setExternalUserType(partner?.type ?? ""))}</PartnerDetail.Badge>
          </PartnerDetail.Content>
        </PartnerDetail.Field>
        <PartnerDetail.Field>
          <PartnerDetail.Label>{t("partner.managerName")}</PartnerDetail.Label>
          <PartnerDetail.Content>{partner?.managerName}</PartnerDetail.Content>
        </PartnerDetail.Field>
        <PartnerDetail.Field>
          <PartnerDetail.Label>{t("partner.address")}</PartnerDetail.Label>
          <PartnerDetail.Content>{partner?.address}</PartnerDetail.Content>
        </PartnerDetail.Field>
        <PartnerDetail.Field>
          <PartnerDetail.Label>{t("partner.descript")}</PartnerDetail.Label>
          <PartnerDetail.Content>{partner?.description}</PartnerDetail.Content>
        </PartnerDetail.Field>
        <PartnerDetail.Field>
          <PartnerDetail.Label>{t("info.createdAt")}</PartnerDetail.Label>
          <PartnerDetail.Content>
            {partner?.creatorUserCode}{" "}
            {partner?.createdAt ? timeUtil(partner?.createdAt ?? "") : ""}
          </PartnerDetail.Content>
        </PartnerDetail.Field>
        <PartnerDetail.Field>
          <PartnerDetail.Label>{t("info.updatedAt")}</PartnerDetail.Label>
          <PartnerDetail.Content>
            {partner?.updaterUserCode} {partner?.updatedAt ? timeUtil(partner?.updatedAt) : ""}
          </PartnerDetail.Content>
        </PartnerDetail.Field>
      </PartnerDetail>
    </>
  );
};
